import { useTranslation } from 'react-i18next';
import * as Env from 'widget/env';

const useGetMessagePreview = () => {
  const { t } = useTranslation();

  const getMessagePreview = (msg: Env.Message) => {
    if (msg.type == 'file') return `📎 ${msg.content || t`File`}`;
    return msg.content;
  };

  return getMessagePreview;
};

export default useGetMessagePreview;
